import { singleValueOrNone } from '@/features/shared/serverUtils/request'
import { type RequestHeaders } from '@shared/request_type'

const BOT_REGEX =
  /(?:googlebot\/|Googlebot-Mobile|Googlebot-Image|Google-InspectionTool|Google favicon|Mediapartners-Google|Storebot-Google|AdsBot-Google|APIs-Google|GoogleOther|Google-Extended|bingbot|Adidxbot|slurp|Applebot|DuckDuckBot|GPTBot|OAI-SearchBot|ChatGPT-User|ClaudeBot|Claude-Web|Meta-ExternalAgent|Meta-ExternalFetcher|FacebookBot|Facebot|PerplexityBot|Perplexity-User|cohere-ai|Bytespider|DuckAssistBot|Amazonbot|Diffbot|ccbot|ahrefsbot|SemrushBot|SemanticScholarBot|smtbot|Screaming Frog SEO Spider|psbot|facebookexternalhit|Twitterbot|LinkedInBot|ia_archiver|archive\.org_bot|CC Metadata|BotifyBot|changedetection|phpcrawl|Python-urllib|python-requests|Go-http-client)/i

export const getIsBot = (headers: RequestHeaders | undefined) => {
  if (!headers) {
    return false
  }
  const userAgent = singleValueOrNone(headers['user-agent'])
  const isBotByUserAgent = Boolean(userAgent && BOT_REGEX.test(userAgent))
  // we set a custom header in botify to allow us to know if the request comes from botify
  const isBotByBotifyHeader = headers['x-botify-shipt'] !== undefined
  // prerender sets x-is-bot: true when rendering pages for crawlers
  const isBotByPrerenderHeader = headers['x-is-bot'] === 'true'
  return isBotByUserAgent || isBotByBotifyHeader || isBotByPrerenderHeader
}
